module.exports = __webpack_public_path__ + "img/inner-space.986ec642.png";